import {Component} from '@angular/core';
import {ListViewItem} from "@domain/common/list-view/list-view-item";
import {BoiteLienService} from "@components/admin/parametre/personnalisation/boite-lien/boite-lien.service";
import {BoiteLien} from "@domain/boitelien/boitelien";

/**
 * Composant d'affichage de la page BoiteLienItem
 *
 * @author Lionel Gimenez
 * @date 15/07/2025
 */
@Component({
    host: {'data-test-id': 'boite-lien-item'},
    selector: 'boite-lien-item',
    templateUrl: './boite-lien-item.component.html'
})
export class BoiteLienItemComponent extends ListViewItem<BoiteLien> {
    /**
     * Constructeur
     */
    constructor(
        private boiteLienService: BoiteLienService
    ) {
        super();
    }

    /**
     * Handler du clique
     */
    onClick(): void {
        //On ouvre la modale
        this.boiteLienService.openDialog(this.data);
    }
}